import { Income } from "../models/calculation-api.types";
import { CalculatorField, CalculatorStep } from "../models/CalculatorStep";

const optionsYesNo = [
  { text: "Nee", value: "false" },
  { text: "Ja", value: "true" },
];

export const familySteps: CalculatorStep[] = [
  {
    field: "Region",
    title: "STATIC: In welke regio woon je?",
    description:
      "STATIC: De basisbedragen verschillen in Vlaanderen, Wallonië of Brussel. Hier kun je de regio selecteren waarvoor je het bedrag wil berekenen.",
    questions: [
      {
        input: "option",
        field: CalculatorField.Region,
        options: [
          { text: "STATIC: Vlaanderen", value: "flanders" },
          { text: "STATIC: Brussel", value: "brussels" },
          { text: "STATIC: Wallonië", value: "wallonia" },
        ],
      },
    ],
  },
  {
    field: "Family",
    title: "STATIC: Hoe ziet jouw gezinssituatie eruit?",
    questions: [
      {
        input: "option",
        title: "STATIC: Bruto gezinsinkomen ouders",
        explanation:
          "STATIC: De Bruto gezinsinkomsten kan je terugvinden op je aanslagbiljet. Alle voorwaarden voor een Sociale Toeslag kan je hier terugvinden",
        field: CalculatorField.GrossIncome,
        options: [
          { text: "STATIC: Inkomen lager dan € 34.526,91", value: Income.Low },
          { text: "STATIC: Inkomen tussen € 34.526,91 en € 40.281,40", value: Income.LowMedium },
          { text: "STATIC: Inkomen tussen € 40.281,40 en € 64.945,93", value: Income.Medium },
          { text: "STATIC: Inkomen boven € 64.945,93", value: Income.High },
        ],
      },
      {
        input: "option",
        title: "Gezinssituatie",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        field: CalculatorField.FamilySituation,
        options: [
          { text: "Samenwonend", value: "couple" },
          { text: "Alleenstaand", value: "single" },
        ],
      },
      {
        input: "option",
        title: "Ben jij of is je partner meer dan 6 maanden ziek of invalide?",
        field: CalculatorField.SickParent,
        options: optionsYesNo,
      },
    ],
  },
  {
    field: "Children",
    questions: [],
    title: "",
  },
];
